
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { format, parseISO } from "date-fns";

interface BookingDetailsDialogProps {
  booking: {
    start_time: string;
    end_time: string;
    status: string;
    lot_count: number;
    parking_spot: {
      address: string;
      owner_name: string;
    };
  };
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onCancelClick: () => void;
  onFeedbackClick: () => void;
  canRequestCancel: boolean;
  canGiveFeedback: boolean;
}

const BookingDetailsDialog = ({
  booking,
  open,
  onOpenChange,
  onCancelClick,
  onFeedbackClick,
  canRequestCancel,
  canGiveFeedback,
}: BookingDetailsDialogProps) => {
  const formatDateTime = (dateString: string) => {
    try {
      // Parse the ISO string and preserve original timezone
      const date = parseISO(dateString);
      return format(date, "dd MMM yyyy, HH:mm");
    } catch (error) {
      console.error('Error formatting date:', error);
      return dateString;
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Booking Details</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <h3 className="font-semibold">{booking.parking_spot.address}</h3>
            <p className="text-sm text-gray-500">Owner: {booking.parking_spot.owner_name}</p>
            <p className="text-sm text-blue-600 font-medium">Lots booked: {booking.lot_count || 1}</p>
          </div>
          <div className="space-y-2">
            <p className="text-sm">
              Start: {formatDateTime(booking.start_time)}
            </p>
            <p className="text-sm">
              End: {formatDateTime(booking.end_time)}
            </p>
            <p className="text-sm font-medium">
              Status: <span className="capitalize">{booking.status}</span>
            </p>
          </div>
          <div className="flex gap-2 justify-end">
            {canRequestCancel && (
              <Button 
                variant="destructive"
                onClick={onCancelClick}
              >
                Request Cancellation
              </Button>
            )}
            {canGiveFeedback && (
              <Button onClick={onFeedbackClick}>
                Give Feedback
              </Button>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default BookingDetailsDialog;
